import React from 'react';
import { isEmpty } from 'lodash';
export function renderLabelWithCheckbox(
  item,
  handleCheckboxChange,
  questionId,
  index,
  disabled,
  showAltText = false
) {
  const isSubOption = /^[0-9]_/.test(item.label);
  return (
    <label
      className={isSubOption ? 'sub-options' : 'custom-label'}
      style={isSubOption ? { marginLeft: '40px' } : {}}
    >
      <div className="ui checkbox">
        <input
          className="hidden"
          readOnly
          disabled={disabled}
          tabIndex="0"
          type="checkbox"
          //value=""
          checked={item.checked}
          onChange={() => handleCheckboxChange(questionId, index)}
        />
        <div
          className="custom-checkbox"
          style={{ paddingTop: '5px' }}
          dangerouslySetInnerHTML={{
            __html: formatCheckBoxString(
              showAltText ? item.altText : item.label
            ),
          }}
        />
      </div>
    </label>
  );
}
export function renderDisabledLabelWithCheckbox(item) {
  const isSubOption = /^[0-9]_/.test(item.label);
  return (
    <label
      className={isSubOption ? 'sub-options' : 'custom-label'}
      style={isSubOption ? { marginLeft: '40px' } : {}}
    >
      <div className="ui checkbox">
        <input
          className="hidden"
          readOnly
          disabled={true}
          tabIndex="0"
          type="checkbox"
          //value=""
          checked={true}
        />
        <div
          className="custom-checkbox"
          style={{ paddingTop: '5px' }}
          dangerouslySetInnerHTML={{
            __html: formatCheckBoxString(item.label),
          }}
        />
      </div>
    </label>
  );
}

const formatCheckBoxString = label => {
  return label.includes('_')
    ? label.substring(label.lastIndexOf('_') + 1)
    : label;
};

const findingCardClasses = (className, findingStatus) => {
  return `${className} ${
    'DROPPED' === findingStatus || 'Abandoned' === findingStatus
      ? 'disabled-finding-card'
      : ''
  }`;
};

const IsFindingsAvailable = data => {
  return (
    data?.collectDataTypes &&
    Object.values(data).some(obj => Object.keys(obj).length > 0)
  );
};

const determineFindingStatus = (selectedReview, citation) => {
  const isAllParentUnchecked =
    isAllUnchecked(selectedReview, citation) &&
    'New Findings' !== citation.collectDataSubType;

  const isAllNewUnchecked =
    isAllUnchecked(selectedReview, citation) &&
    'New Findings' === citation.collectDataSubType;

  const isFindingDisabled = citation?.isActive === false;

  if (
    ['signed', 'Shipped', 'Cancelled'].includes(selectedReview?.reviewStatus) ||
    ['finalized'].includes(selectedReview?.reportStage) ||
    isAllParentUnchecked ||
    isAllNewUnchecked ||
    isFindingDisabled
  ) {
    return 'DROPPED';
  }
  return citation?.findingStatus;
};

const isAllUnchecked = (selectedReview, citation) => {
  return (
    'Follow-up' === selectedReview.reviewType &&
    !isEmpty(citation?.collectedData) &&
    citation.collectedData.every(arr =>
      arr.collectedOptions.every(item => !item.checked)
    )
  );
};

const prependStringToKeys = (obj, prefix) => {
  const result = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = `${prefix} - ${key}`;
      result[newKey] = obj[key];
    }
  }
  return result;
};

export {
  formatCheckBoxString,
  findingCardClasses,
  IsFindingsAvailable,
  determineFindingStatus,
  prependStringToKeys,
  isAllUnchecked,
};
